import { css } from '@emotion/react';
import { setOpacity } from 'styles/utils';
import { IColors } from 'types/colors';

export const dialogCloseBtnCss = css`
	&.MuiIconButton-root {
		position: absolute;
		right: 3px;
		top: 4px;
	}
`;

export const dialogPaddingCss = css`
	padding: 10px;
`;

export const dialogErrorColorCss = css`
	color: red;
`;

export const dialogCss = (colors: IColors) => css`
	.MuiBackdrop-root {
		background-color: ${setOpacity(colors.bg_white || '', 0.7)};
	}
`;

export const dialogTitleCss = (colors: IColors) => css`
	text-align: center;
	width: 100%;
	color: ${colors.tx_text_primary};
	.MuiTypography-root {
		color: inherint;
	}
`;

export const fullWidthCss = css`
	width: 100%;
	padding: 10px 0;
`;

export const forgotPasswordCss = css`
	display: contents;
	.MuiGrid-grid-xs-12 {
		padding: 30px;
	}
`;

export const backToLoginCss = (colors: IColors) => css`
	color: ${setOpacity(colors.tx_text_primary || '', 0.37)};
	padding: 0px 20px;
	font-size: 1.6rem;
	cursor: pointer;
`;

export const forgotPasswordTextCss = (colors: IColors) => css`
	text-align: center;
	width: 100%;
	color: ${colors.tx_text_primary};
	&.MuiTypography-h5 {
		font-weight: normal;
		font-size: 1.8rem;
		padding: 30px;
	}
`;

export const linkPaddingCss = (colors: IColors) => css`
	padding: 15px 0;
	font-size: 1.4rem;
	text-decoration: underline;
	font-weight: bold;
	color: ${colors.tx_text_primary};
	cursor: pointer;
`;
